<div>
  <div class="ripple-background">
    <!-- <div class='circle xxlarge shade1'></div>
    <div class='circle xlarge shade2'></div>
    <div class='circle large shade3'></div>
    <div class='circle mediun shade4'></div>
    <div class='circle small shade5'></div> -->

    <div class="glass_container center_glassContainer">

      <div class="logo-container">
        <img class="imgItem" src="/assets/img/logo Mapix.png">
      </div>

      <div class="main-container">
        <loading [isLoading]="isLoading"></loading>

        <form [formGroup]="formLogin" (ngSubmit)="Login()">
          
          <p class="subtitleLabel">Usuario</p>
          <mat-form-field class="full-width-input">
            <input matInput placeholder="Usuario" formControlName="email" required type="email" />
            <mat-icon matSuffix>email</mat-icon>
            <mat-error>Por favor introduce un usuario válido</mat-error>
          </mat-form-field>
          <mat-error *ngIf="loginInvalid">Datos incorrectos.</mat-error>

          <p class="subtitleLabel">Contraseña</p>
          <mat-form-field class="full-width-input">
            <input matInput [type]="hidePassword ? 'password' : 'text'" placeholder="Contraseña" formControlName="password" required />
            <mat-icon matSuffix (click)="togglePasswordVisibility()">
              {{ hidePassword ? 'visibility_off' : 'visibility' }}
            </mat-icon>
            <mat-error>Por favor introduce una contraseña válida</mat-error>
          </mat-form-field>
          
          <button mat-button color="accent" [disabled]="!formLogin.valid || isLoading" class="btnEntrar" type="submit">
            <img class="enter-icon-mobile mr-5" src="/assets/img/icon_entrar.png" alt="Entrar" style="width: 1.3em;">
            <span>Entrar</span>
          </button>
        </form>

        <div class="mt-2 btn-psw" >
          <mat-icon class="mr-5">lock</mat-icon>
          <a (click)="recoveryPasswordDialog()">Recuperar Contraseña</a>
        </div>

      </div>
    </div>

    <div class="privacity">
      <b>Aviso de privacidad</b>
      <label>-V6.3.78</label>
    </div>
  </div>
</div>